






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import { EResidentStatus } from '@zunta/configurations'
import { RESIDENT_STATUS_LABEL_MAP } from '@/constants'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusResident extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }

    switch (this.$props.status) {
      case EResidentStatus.ACTIVE:
        return EStatusType.success
      case EResidentStatus.WAITING:
        return EStatusType.pending
      case EResidentStatus.INACTIVE:
        return EStatusType.error
      default:
        return EStatusType.default
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
   return RESIDENT_STATUS_LABEL_MAP[this.$props.status]
  }
}
